"use client";

import clsx from "clsx";

/**
 * Presenter-chrome subcomponent: manual-mode toggle.
 * When on, scenario playback pauses before each ui.ScreenChanged.
 * Renders a "Next screen →" button below when active.
 */
export function ManualModeToggle({
  manualMode,
  onToggle,
  onNextScreen,
}: {
  manualMode: boolean;
  onToggle: () => void;
  onNextScreen: () => void;
}) {
  return (
    <>
      <div className="mt-3 flex items-center justify-between rounded border border-state-verified/30 bg-orbitra-ink/40 px-2 py-1.5">
        <div className="flex flex-col">
          <span className="text-orbitra-teal-soft uppercase tracking-[0.18em]">Manual mode</span>
          <span className="text-[9px] text-orbitra-muted">N · advance to next screen</span>
        </div>
        <button
          onClick={onToggle}
          aria-pressed={manualMode}
          className={clsx(
            "rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider transition-state",
            manualMode
              ? "bg-state-verified text-orbitra-ink shadow-[0_0_12px_var(--state-verified-glow)]"
              : "border border-orbitra-muted/40 text-orbitra-muted hover:text-orbitra-paper",
          )}
        >
          {manualMode ? "● on" : "○ off"}
        </button>
      </div>
      {manualMode && (
        <button
          onClick={onNextScreen}
          className="mt-2 w-full rounded border border-state-verified bg-state-verified/10 px-2 py-1.5 text-state-verified hover:bg-state-verified/20"
        >
          Next screen →
        </button>
      )}
    </>
  );
}
